import { supabase, publicSupabase } from '@/lib/supabase';
export async function materialOrderAccess(id, action = 'ensure', grouped = false) {
  const { data, error } = await supabase.rpc(grouped ? 'mfg_supplier_material_order_access' : 'mfg_material_order_access', { p_order: id, p_action: action });
  if (error) throw new Error(error.message);
  return data;
}
export async function readMaterialOrder(token) {
  const { data, error } = await publicSupabase.rpc('mfg_supplier_material_order_read', { p_token: token });
  if (error) throw new Error(error.message);
  return data;
}
export function materialOrderUrl(token) {
  const url = new URL(import.meta.env.VITE_SUPPLIER_RETURN_BASE_URL || window.location.href);
  url.search = '';
  url.hash = `/pedido-material/${token}`;
  return url.href;
}

export async function confirmMaterialOrder(order, quantity, delivery, notes) {
  const { data, error } = await supabase.rpc('mfg_confirm_material_order', { p_order: order.id, p_quantity: quantity, p_delivery: delivery || null, p_notes: notes, p_revision: order.confirmation_revision || 0 });
  if (error) throw new Error(error.message);
  return data;
}

export async function deleteMaterialOrder(order) {
  const { error } = await supabase.rpc(order.lines ? 'mfg_delete_supplier_material_order' : 'mfg_delete_material_order', order.lines ? { p_order: order.id, p_lines: order.lines.map(l => ({ id: l.id, revision: l.confirmation_revision })) } : { p_order: order.id, p_revision: order.confirmation_revision || 0 });
  if (error) throw new Error(error.message);
}

export async function createSupplierMaterialOrder(id, productionOrderId, supplier, lines) {
  const { data, error } = await supabase.rpc('mfg_create_supplier_material_order', { p_id: id, p_order: productionOrderId, p_supplier: supplier.key, p_name: supplier.supplier, p_lines: lines });
  if (error) throw new Error(error.message);
  return data;
}
export async function confirmSupplierMaterialOrder(order, lines, token) {
  const client = token ? publicSupabase : supabase;
  const { data, error } = await client.rpc(token ? 'mfg_supplier_material_order_confirm' : 'mfg_supplier_material_order_confirm_internal', { ...(token ? { p_token: token } : { p_order: order.id }), p_lines: lines });
  if (error) throw new Error(error.message);
  return data;
}

export async function receiveMaterial(id, orderId, group, quantity, orders) {
  const { data, error } = await supabase.rpc('mfg_receive_material', {
    p_id: id, p_order: orderId, p_key: group.key, p_quantity: quantity,
    p_orders: orders.map(o => ({ id: o.id, revision: o.confirmation_revision || 0 })),
    p_details: { supplier: group.supplier, name: group.name, reference: group.reference, color: group.color, unit: group.unit },
  });
  if (error) throw new Error(error.message);
  return data;
}
export async function deleteMaterialReceipt(id) {
  const { error } = await supabase.rpc('mfg_delete_material_receipt', { p_receipt: id });
  if (error) throw new Error(error.message);
}

export async function fetchPendingMaterialConfirmations() {
  const { data, error } = await supabase.rpc('mfg_pending_material_confirmations');
  if (error) throw new Error(error.message);
  return data || [];
}
export async function reviewMaterialConfirmation(order) {
  const { data, error } = await supabase.rpc('mfg_review_material_confirmation', {
    p_order: order.id, p_submitted_at: order.supplier_confirmed_at,
    p_lines: order.lines.map(line => ({ id: line.id, revision: line.confirmation_revision })),
  });
  if (error) throw new Error(error.message);
  window.dispatchEvent(new Event('material-confirmations-updated'));
  return data;
}
export async function fetchMaterialConfirmationOrder(id) {
  const [batch, lines] = await Promise.all([
    supabase.from('mfg_supplier_material_orders').select('id,production_order_id,order_number,supplier_name,created_at,supplier_confirmed_at,supplier_reviewed_at').eq('id', id).single(),
    supabase.from('mfg_production_material_orders').select('*').eq('supplier_order_id', id).order('created_at'),
  ]);
  if (batch.error || lines.error) throw new Error((batch.error || lines.error).message);
  return { ...batch.data, lines: lines.data.map(line => ({ ...line, ...line.supplier_order_line })) };
}
